import { useState } from "react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Accordion, Typography } from "@aviary";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

interface Props {
  children: ReactNode;
  orderTotal: number;
}

const JourneyMobileOrderSummary = ({ children, orderTotal }: Props) => {
  const { t } = useTranslation();
  const [accordion, setAccordion] = useState(false);

  const formatPrice = (price: number) => `$${price.toFixed(2)}`;

  return (
    <Accordion
      coreTriggerContent={
        <Typography isSecondaryWeight isMarginless>
          {t(
            accordion
              ? l.journeyCheckout.orderSummary.hideOrderSummary
              : l.journeyCheckout.orderSummary.showOrderSummary
          )}
        </Typography>
      }
      secondaryTriggerContent={
        <Typography isSecondaryWeight isMarginless>
          {formatPrice(orderTotal)}
        </Typography>
      }
      onChange={setAccordion}
      chevronPosition="start"
      isContentMarginless
    >
      {children}
    </Accordion>
  );
};

export { JourneyMobileOrderSummary };
